import { useTranslation } from 'react-i18next'
import { useHydrated } from 'remix-utils/use-hydrated'

import { useDarkMode } from '~/shared/components/DarkMode/hook'
import pageNotFoundlogoDarkMode from '~/shared/images/error/404-dark.svg'
import pageNotFoundLogo from '~/shared/images/error/404.svg'

export default function PageNotFound() {

  const { isDark } = useDarkMode()
  const { t } = useTranslation()
  const isHydrated = useHydrated()

  return (
    <div className="sp-not-found flex flex-col h-screen sm:bg-neutral-00 lg:bg-neutral-05 dark:bg-neutral-98 px-6 pt-20">
      <section className="absolute flex justify-center translate-x-1/2 -translate-y-1/2 top-1/2 right-1/2">
        <div className="sp-not-found-card flex sm:flex-col sm:gap-8 lg:flex-row md:gap-20 rounded-md py-6 px-16 bg-white dark:sm:bg-transparent lg:dark:bg-neutral-95">
          <div className="flex flex-col sm:gap-4 md:gap-5 lg:gap-0 justify-center lg:w-83.75 sm:text-center lg:text-left">
            <p className="sp-not-found-title text-neutral-50 dark:text-neutral-50 sm:text-[36px] leading-10.5 lg:text-[43px] lg:leading-13.5">
              {t('components.ui.404.oops')}
            </p>
            <p className="sp-not-found-message text-neutral-95 dark:text-neutral-20 sm:text-h3 md:text-h1 lg:text-[43px] lg:leading-13.5">
              {t('components.ui.404.message')}
            </p>
          </div>
          {isHydrated && <img
            src={isDark() ? pageNotFoundlogoDarkMode : pageNotFoundLogo}
            alt="404"
            className="sm:max-w-65 sm:h-59 md:max-w-93 md:h-77.75"
          />}
        </div>
      </section>
    </div>
  )
}
